import { documentApi } from "@api/documents";
import { DocumentCardGroup } from "@modules/Document/DocumentCardGroup";
import { FrontSiteRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Container, Grid } from "semantic-ui-react";
import "./SectionsWrapper.css";

export default class SectionsWrapper extends Component {
  renderSection(title, sortField, viewAllQuery, size, id) {
    return (
      <Container textAlign="center" className="fs-landing-page-section" id={id}>
        <DocumentCardGroup
          title={title}
          headerClass="section-header highlight"
          fetchDataMethod={documentApi.list}
          fetchDataQuery={documentApi
            .query()
            .withDocumentType("BOOK")
            .sortBy(sortField)
            .withSize(size * 2) // Fetch 2x the target to account for filtering
            .qs()}
          viewAllUrl={FrontSiteRoutes.documentsListWithQuery(viewAllQuery)}
          targetCount={size}
        />
      </Container>
    );
  }

  render() {
    const { size } = this.props;
    return (
      <Container fluid className="fs-landing-page-section-wrapper">
        {/* Desktop / Tablet */}
        <div className="desktop-only">
          {this.renderSection(
            "Recent Books",
            "-created",
            "&sort=created&order=desc",
            size,
            "recent-books"
          )}
          {this.renderSection(
            "Popular Books",
            "-mostloaned",
            "&sort=mostloaned&order=desc",
            size,
            "most-loaned"
          )}
        </div>
        {/* Mobile */}
        <div className="mobile-only">
          <Grid padded stackable columns={1} className="fs-landing-page-mobile">
            <Grid.Row>
              <Grid.Column>
                {this.renderSection(
                  "Recent Books",
                  "-created",
                  "&sort=created&order=desc",
                  3, // show fewer items on mobile
                  "recent-books-mobile"
                )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {this.renderSection(
                  "Popular Books",
                  "-mostloaned",
                  "&sort=mostloaned&order=desc",
                  3,
                  "most-loaned-mobile"
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Container>
    );
  }
}

SectionsWrapper.propTypes = {
  size: PropTypes.number,
};

SectionsWrapper.defaultProps = {
  size: 5,
};
